import clsx from "clsx"
import { FC, ReactNode } from "react"
import { PlaceholderImage } from "src/components/icons/PlaceholderImage"
import { Img } from "src/components/unstyled/Img"
import { ImageFormat, ProductImageSize, toProductImageCdnUrl } from "src/utilities/productImages"

export type ThumbnailProps = {
  src: string | null | undefined
  alt: string | null | undefined
  format: ImageFormat
  size: ProductImageSize
  className?: string
  children?: ReactNode
}

export const Thumbnail: FC<ThumbnailProps> = ({ src, alt, format, size, className, children }) => {
  return (
    <div
      className={clsx("relative overflow-hidden rounded-xl bg-gray-200 p-4 shadow-sm", className, {
        "aspect-4/5": format === "vertical",
        "aspect-1/1": format === "square",
        "aspect-3/2": format === "horizontal",
      })}
    >
      {src ? (
        <Img
          src={toProductImageCdnUrl({ src, format, size })}
          alt={alt}
          className="absolute inset-0 size-full rounded-lg object-cover"
        />
      ) : (
        <div className="absolute inset-0 flex size-full items-center justify-center">
          <PlaceholderImage />
        </div>
      )}

      {children}
    </div>
  )
}
